import type { PeriodoPlanilla } from '../../periodos/types/periodo';

// ── Planilla Cabecera ─────────────────────────────────────────

export interface PlanillaCabecera {
  idPlanilla: number;
  idPeriodo: number;
  descripcion: string;
  tipoPlanilla: string;
  estado: string;
  fechaCreacion: string;
  fechaCalculo: string | null;
  totalRemuneraciones: number;
  totalDescuentos: number;
  totalAportes: number;
  totalNeto: number;
  cantidadTrabajadores: number;
  periodo?: PeriodoPlanilla;
}

export const ESTADOS_PLANILLA = [
  { value: 'BORRADOR', label: 'Borrador', color: 'default' as const },
  { value: 'CALCULADA', label: 'Calculada', color: 'info' as const },
  { value: 'APROBADA', label: 'Aprobada', color: 'success' as const },
  { value: 'CERRADA', label: 'Cerrada', color: 'warning' as const },
];

export const TIPOS_PLANILLA = [
  { value: 'MENSUAL', label: 'Mensual' },
  { value: 'GRATIFICACION', label: 'Gratificación' },
  { value: 'UTILIDADES', label: 'Utilidades' },
  { value: 'LIQUIDACION', label: 'Liquidación' },
];

export const initialPlanilla: PlanillaCabecera = {
  idPlanilla: 0,
  idPeriodo: 0,
  descripcion: '',
  tipoPlanilla: 'MENSUAL',
  estado: 'BORRADOR',
  fechaCreacion: '',
  fechaCalculo: null,
  totalRemuneraciones: 0,
  totalDescuentos: 0,
  totalAportes: 0,
  totalNeto: 0,
  cantidadTrabajadores: 0,
};

export interface PlanillaFormErrors {
  idPeriodo?: string;
  descripcion?: string;
  tipoPlanilla?: string;
}

// ── Planillón (vista tabular) ─────────────────────────────────

export interface PlanillonData {
  planilla: PlanillaCabecera;
  periodo: PeriodoPlanilla;
  filas: PlanillonRow[];
  columnas: ConceptoColumna[];
  totales: PlanillonTotales;
}

export interface PlanillonRow {
  idPlanillaDetalle: number;
  idTrabajador: number;
  nombreTrabajador: string;
  documento: string;
  area: string;
  regimenPensionario: string;
  diasLaborados: number;
  diasNoLaborados: number;
  diasSubsidiados: number;
  horasNormales: number;
  horasExtras25: number;
  horasExtras35: number;
  horasExtras100: number;
  horasExtraNocturna: number;
  minutosTardanza: number;
  conceptoMontos: Record<number, number>;
  totalRemuneraciones: number;
  totalDescuentos: number;
  totalAportes: number;
  netoPagar: number;
}

export interface ConceptoColumna {
  idConcepto: number;
  codigo: string;
  descripcion: string;
  tipoConcepto: string; // R, D, A
  orden: number;
}

export interface PlanillonTotales {
  totalRemuneraciones: number;
  totalDescuentos: number;
  totalAportes: number;
  totalNeto: number;
  cantidadTrabajadores: number;
}

// ── Concepto en detalle ──────────────────────────────────────

export interface DetalleConcepto {
  idPlanillaDetalleConcepto: number;
  idPlanillaDetalle: number;
  idConcepto: number;
  monto: number;
  porcentaje: number | null;
  baseCalculo: number | null;
  detalleCalculo: string | null;
  esCalculado: boolean;
  concepto?: {
    idConcepto: number;
    codigo: string;
    descripcion: string;
    tipoConcepto: string;
  };
}

// ── Detalle editable ──────────────────────────────────────────

export interface PlanillaDetalleUpdate {
  idPlanillaDetalle: number;
  idPlanilla: number;
  idTrabajador: number;
  diasLaborados: number;
  diasNoLaborados: number;
  diasSubsidiados: number;
  horasNormales: number;
  horasExtras25: number;
  horasExtras35: number;
  horasExtras100: number;
  horasExtraNocturna: number;
  minutosTardanza: number;
}
